module.exports = __webpack_public_path__ + "static/img/p10.52c736a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p10.png
// module id = 235
// module chunks = 1